import React, { useState, useCallback, useEffect } from 'react';
import { Input, Button, Typography, Menu, Tag } from 'antd';
import { PlusOutlined, SearchOutlined, CommentOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import ChatMenuGroup from './chatlog';
import { useNavigate, useParams } from 'react-router-dom';
import { useAIChat } from '../AiChatProvider';
import OnedocLogo from '../../../components/svgs/OnedocLogo/OnedocLogo';
import { useChatActions } from '../hooks/useChatActions';

const { Text } = Typography;
const OneDocAISidebar = () => {
  const [query, setQuery] = useState('');
  const [selectedKeys, setSelectedKeys] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchAllConversations, conversations } = useAIChat();
  const { handleNewChat, handleChatClick } = useChatActions();

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchAllConversations(query);
    }, 300);
    return () => clearTimeout(timeout);
  }, [query]);

  useEffect(() => {
    if (id) {
      setSelectedKeys([String(id)]);
    } else {
      setSelectedKeys([]);
    }
  }, [id]);

  const changeConversations = useCallback(
    (chatId) => {
      // Update selected keys for UI state
      setSelectedKeys(chatId ? [chatId] : []);

      // Handle chat navigation
      if (chatId) {
        handleChatClick(chatId);
      } else {
        handleNewChat();
      }
    },
    [handleChatClick, handleNewChat]
  );

  return (
    <div
      style={{
        width: '266px',
        backgroundColor: '#f9fafb',
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        fontSize: '0.875rem',
        height: '100%',
        backgroundColor: '#f3f4f6',
        transition: 'width 0.3s ease',
        overflow: 'auto',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          marginBottom: '1rem',
        }}
      >
        <div
          style={{
            width: '0px',
            height: '0px',
            borderRadius: '50%',
            backgroundColor: '#3B82F6',
          }}
        />
        <OnedocLogo style={{ height: '28px' }} />
      </div>

      {/* Divider line */}
      <div style={{ borderBottom: '1px solid #e0e0e0', marginBottom: '0.5rem' }} />

      {/* Header Row */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '0.5rem',
        }}
      >
        <Button
          size="small"
          icon={<ArrowLeftOutlined />}
          type="text"
          onClick={() => navigate('/home')}
          style={{ padding: '4px', boxShadow: 'none' }}
        />

        <Text
          strong
          style={{
            fontSize: '1rem',
            flexGrow: 1,
            textAlign: 'left',
            margin: 0,
          }}
        >
          OneDoc AI{' '}
          <Tag
            style={{
              borderRadius: '10px',
              backgroundColor: '#f0f0f0',
              color: '#000',
              fontWeight: 'bold',
              padding: '0 8px',
              fontSize: '1rem',
              lineHeight: '20px',
            }}
          >
            Beta
          </Tag>
        </Text>
        <Button
          size="small"
          icon={<PlusOutlined />}
          type="text"
          onClick={() => changeConversations(null)}
          style={{ padding: '4px', boxShadow: 'none' }}
        />
      </div>

      <Input
        size="medium"
        placeholder="Search chat"
        suffix={<SearchOutlined />}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      <Menu mode="inline" selectedKeys={selectedKeys} style={{ background: 'transparent', border: 'none' }}>
        {Object.entries(conversations).map(([key, value]) => {
          if (!value || value.length === 0) return null;

          return (
            <ChatMenuGroup
              key={key}
              title={key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()}
              chats={value}
              onChatClick={changeConversations}
              icon={<CommentOutlined />}
            />
          );
        })}
      </Menu>
    </div>
  );
};

export default OneDocAISidebar;
